import "./question.css";
import {useMemo} from 'react';
import { BusinessOutlined, PersonOutline } from "@material-ui/icons";
import { head, remarkStyle, signature } from "../helper";
import DefaultImage from "../../../../images/Navbar/2xcell-signature.png";
import { htmlDecode } from "../../../../utils/parse";
import { QuestionImg, QuestionMedia } from "../../../LearningResources/Assement/Image";

function Description({ image, description }) {
  return (
      <div className="description">
        {image ? <QuestionImg image={image} /> : null}
        <p
          dangerouslySetInnerHTML={{
            __html: htmlDecode(description),
          }}
        ></p>
      </div>
  );
}

export default function OTQuestionCard({
  color = "",
  number,
  question,
  children,
}) {

   const language = useMemo(() => {
   return question.language && question.language.toLowerCase();
  },[question.language]);

  return (
    <div className="ot_question_card">
      <div className="question-label" style={remarkStyle(color)}>
        {question.label}
      </div>
      <div className="question-content" style={head(color)}>
        <div className="question_info">
          <div
            className="title"
            dangerouslySetInnerHTML={{
              __html: htmlDecode(`Q${number}. &nbsp; ${question.title}`),
            }}
          ></div>
          {question.description?.assertion ? (
            <Description
              description={`${language === "hindi"?"कथन (A)":"Assertion (A)"}: ${question.description?.assertion || ""}`}
              image={question.assertImg}
            />
          ) : null}
          {question.description?.reasoning ? (
            <Description
              description={`${language === "hindi"?"कारण (R):":"Reasoning (R)"} ${question.description?.reasoning || ""}`}
              image={question.reasonImg}
            />
          ) : null}
        </div>
        <div className="question-input">
          {question.image ? <QuestionMedia url={question.image} /> : null}
          {children}
        </div>

        <div className="question-signature">
          {question?.signature?.role === "admin" ? (
            <img
              src={DefaultImage}
              className="signature"
              style={{ ...signature(color) }}
            />
          ) : (
            <div className="signature" style={signature(color)}>
              <span>
                <PersonOutline className="icon" />{" "}
                {question.signature?.teacherName || ""}
              </span>
              <span>
                <BusinessOutlined className="icon" />{" "}
                {question.signature?.schoolName || ""}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
